import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'companies',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'companiesList',
      component: () => import('@/views/companies/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':companyId/applications',
      name: 'companieApplicationList',
      props: true,
      component: () => import('@/views/companies/applications/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
  ],
});
